// extracted by mini-css-extract-plugin
module.exports = {"is-selected":"SelectSuiteButton_is-selected__vlhTt","isSelected":"SelectSuiteButton_is-selected__vlhTt"};